import { SchemaData, UseUpdateProps } from "./types";
import { useCallback } from "react";
import { JsonFormsStateProps } from "components/CRPComponents/JsonForm/JsonFormsComponent/types";
import { UPDATE_QUERY, UpdateGql } from "../queries/update";
import { ApiMailerRequest } from "data/queries/ApiMailer";

export default function useUpdate({ queryParam }: UseUpdateProps) {
  const handleSave = useCallback(
    async (state: JsonFormsStateProps<SchemaData>) => {
      const { updatedAt, createdAt, subjectDefault, sendCopyTo, ...data } = state?.data;
      console.log({ queryParam });

      console.log(subjectDefault, sendCopyTo);

      const response = await ApiMailerRequest<UpdateGql>({
        query: UPDATE_QUERY,
        variables: {
          data: {
            subjectDefault,
            sendCopyTo,
            name: queryParam,
          },
        },
      });

      if (response?.data?.errors) {
        console.log(response?.data?.errors);
        throw response.data.errors[0];
      }
      if (!response?.data?.data) {
        throw new Error("Ops. Sem resposta!");
      }
      return response;
    },
    [queryParam]
  );

  return {
    handleSave,
  };
}
